export const FREE_ADMIN_FEE_MISSION_TYPE = 'free_admin_fee_mission';
export const FREE_ADMIN_FEE_SEGMENTATION_CONFIG_KEY = 'vp-free-admin-segmentation';
export const FREE_ADMIN_FEE_MISSION_CONFIG_KEY = 'mitra-free-admin-fee-mission-config';
export const FREE_ADMIN_FEE_MISSION_TOGGLE_ID = 'mitra-free-admin-fee-mission-enable';
export const FREE_ADMIN_FEE_JOIN_STATUS = 'ongoing';

export const FREE_ADMIN_FEE_SECTION_STATE = {
  HIDDEN: 'hidden',
  AVAILABLE: 'available',
  ON_GOING: 'ongoing',
  SUCCEEDED: 'succeeded',
  SUCCEEDED_EXHAUSTED: 'succeeded_exhausted',
  FAILED: 'failed',
};

export const FREE_ADMIN_FEE_MISSION_PARAMS = {
  mission_type: FREE_ADMIN_FEE_MISSION_TYPE,
  limit: 10,
  offset: 0,
};
